import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuPlanParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: MenuPlanParamsState = {
  params: null,
};

const initiateMenuPlanSliceParams = createSlice({
  name: 'initiateMenuPlanParams',
  initialState,
  reducers: {
    setMenuPlanParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setMenuPlanParams } = initiateMenuPlanSliceParams.actions;

export default initiateMenuPlanSliceParams.reducer;
